import { NavigationIcons } from 'Components/icons/navigation/enIcons';

export const Groups = Object.freeze([
  { name: 'Dashboard', icon: 'mdi-view-dashboard-outline' },
  {
    name: 'EN.Facts - Digitale Immobilienwirtschaft',
    icon: 'icon-en_icon_32x32_suche',
  },
  {
    name: 'EN.Power - Digitaler Energieversorger',
    icon: 'icon-en_icon_32x32_zaehler',
  },
  { name: 'Administration',
    icon: 'icon-en_icon_32x32_schluessel'
  },
  { name: 'Development',
    icon: 'icon-en_icon_32x32_lagerraum' 
  },
]);

export const GroupIconMap = Object.freeze(
  Object.fromEntries(Groups.map((group) => [group.name, group.icon]))
);

// Names of groups which should show the EnPowerSwitcher inline in the navigation
export const PowerSwitcherGroups = Object.freeze([
  'EN.Power - Digitaler Energieversorger'
]);

// Mapping of subgroup (child group) display names to mdi icon names
export const SubgroupIcons = Object.freeze({
  'Account': NavigationIcons.ACCOUNTS,
  'Belieferungen': NavigationIcons.ENFLOW,
  'Bestandsdaten': NavigationIcons.RENTALDATA,
  'EN.Tab': NavigationIcons.ENTAB,
  'Kundenportal': NavigationIcons.CUSTOMER,
  'Nutzer & Accounts': NavigationIcons.USER,
  'Sonstiges': NavigationIcons.OTHER,
  'Tools für Energieversorger': NavigationIcons.TOOLS,
  'Zählerstandserfassung': NavigationIcons.ENCOUNT,
  'Component Documentation': NavigationIcons.DEVELOPMENT,
});
